import React, { useEffect, useState } from "react";
import RedirectCheckout from "../../components/HelperComponent";
import { useLazyGetSignedFieldsQuery } from "../../redux/services/orderService";
import CryptoJS from "crypto-js";
import { Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

const PayByCard = () => {
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState<string | null>(null);

  const [customerId, setCustomerId] = useState<string>("");

  const [signedFields, setSignedFields] = useState<Record<string, string> | null>(null);
  const [paymentUrl, setPaymentUrl] = useState<string | undefined>(undefined);
  const [orderReference, setOrderReference] = useState<string>("");

  const [getSignedFields, { isLoading }] = useLazyGetSignedFieldsQuery();

  // const getUTCTime = () => new Date().toISOString().split(".")[0] + "Z";

  useEffect(() => {
    // Get the orderId from query parameters
    const orderIdFromUrl = searchParams.get('orderId');
    const customerIdFromUrl = searchParams.get('customerId');

    if (customerIdFromUrl) {
      setCustomerId(customerIdFromUrl);
    }

    if (orderIdFromUrl) {
      setOrderId(orderIdFromUrl);
    } else {
      // Optional: redirect to error page or home
      // navigate('/');
    }
  }, [searchParams]);

  useEffect(() => {
    const build = async () => {
      if (!orderId) return;

      const res = await getSignedFields({
        orderId,
        customerId: ""
      }).unwrap();

      let signedFieldNames =
        res.signedFieldNames +
        ",override_custom_receipt_page,override_custom_cancel_page,override_custom_failure_page";

      setPaymentUrl(res.paymentUrl || undefined);

      const fields: Record<string, string> = {
        access_key: res.accessKey,
        profile_id: res.profileId,
        transaction_uuid: res.transactionUuid,
        signed_field_names: signedFieldNames,
        unsigned_field_names: res.unsignedFieldNames,
        signed_date_time: res.signedDateTime,
        locale: res.locale,
        transaction_type: res.transactionType,
        reference_number: res.referenceNumber,
        amount: String(res.amount),
        currency: res.currency,
        bill_to_forename: "",
        bill_to_surname: "",
        bill_to_email: "",
        bill_to_address_line1: "",
        bill_to_address_city: "",
        bill_to_address_postal_code: "",
        bill_to_address_state: res.billToAddressState,
        bill_to_address_country: res.billToAddressCountry,
        // 🔥 Clean URL without parameters
        override_custom_receipt_page: `${window.location.origin}/payment-success/card`,
        override_custom_cancel_page: `${window.location.origin}/payment/cancel`,
        override_custom_failure_page: `${window.location.origin}/payment/failure`,
      };

      const secret = process.env.REACT_APP_CYBERSOURCE_SECRET_KEY || "";
      const dataToSign = fields.signed_field_names
        .split(",")
        .map((f) => `${f}=${fields[f]}`)
        .join(",");
      const hash = CryptoJS.HmacSHA256(dataToSign, secret);
      fields.signature = CryptoJS.enc.Base64.stringify(hash);

      setSignedFields(fields);
      setOrderReference(res.referenceNumber || "");
    };

    build().catch(console.error);
  }, [getSignedFields, orderId, customerId]);

  // Your component logic here
  if (!orderId) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Order ID Required</h4>
          <p>No order ID found in the URL. Please make sure you accessed this page correctly.</p>
        </div>
      </div>
    );
  }

  if (!signedFields) {
    return (
      <div
        className="p-3 d-flex align-items-center justify-content-center"
        style={{ minHeight: "50vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" role="status" />
          <div className="mt-3">
            {isLoading ? "Preparing payment…" : "Initializing…"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <RedirectCheckout
        signedFields={signedFields}
        orderReference={orderReference}
        customerId={customerId}
        orderId={orderId}
        paymentUrl={paymentUrl}
      />
    </div>
  );
};

export default PayByCard;
